<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosRegionSetting"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="deptIdList" label="区域">
              <!-- <CustomerAreaCascader
                appId="cos_lbu"
                deptInfoId="3853844"
                type="search"
                :multiple="true"
                v-model:ids="queryForm.deptIdList"
              /> -->
              <CosCascader
                placeholder="请选择"
                type="search"
                :options="deptInfo4List"
                :fieldNames="{ label: 'label', value: 'id', children: 'children' }"
                appId="cos_lbu"
                multiple
                v-model:ids="queryForm.deptIdList"
              />
            </dc-form-item>
            <dc-form-item name="deptManagerId" label="查看人">
              <user-select v-model:value="queryForm.deptManagerId" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'deptManager'">
            {{ record.deptManagerInfo.map((emp) => `${emp.employeeName}(${emp.employeeNo})`).join(',') }}
          </template>
          <template v-if="column.dataIndex === 'updateBy'">
            {{ `${record.updateByName}(${record.updateBy})` }}
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'lbu_region_setting_edit_btn'"
                >编辑</a-button
              >
              <a-button type="link" @click="deleteRow(record)" v-permission="'lbu_region_setting_delete_btn'"
                >删除</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'lbu_region_setting_add_btn'">新增</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { ref, computed, onMounted } from 'vue'
import {
  regionSettingList,
  deleteRegionSetting
} from '@/api/yuntuSales/regionSetting'
import { listByParamCodes } from '@/api/common'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { Modal as AModal } from 'ant-design-vue'
import { getDeptInfo } from '@/api/common'
export default { name: 'DcCosLbuRegionSetting' }
</script>
  <script setup lang="ts">
const editModalRef = ref<{ toggle: (row?: any) => void }>()

const tableRef = ref()
const queryForm = ref({})
const deptInfo4List = ref([])

const fetchDeptInfo = async () => {
  const res = await getDeptInfo({ appId: 'cos_lbu', rootId: '3853844' })
  deptInfo4List.value = res.data?.deptInfo[0]?.children
  deptInfo4List.value.forEach((item: any) => {
    if (item.children && item.children.length) {
      item.children.forEach((o: any) => {
        if (o.children) delete o.children
      })
    }
  })
}
// 获取列表
const fetch = async (params: any, callBack: (res: any) => void) => {
  try {
    const res = await regionSettingList({ ...params })
    callBack(res)
  } catch (error) {
    console.log('fetcherror: ', error)
  }
}

const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  { title: '区域', dataIndex: 'deptName' },
  { title: '查看人', dataIndex: 'deptManager' },
  { title: '更新人', dataIndex: 'updateBy' },
  { title: '更新时间', dataIndex: 'updateTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: any) => {
  editModalRef.value?.toggle(_row)
}

const deleteRow = (row: any) => {
  Modal.delete({
    name: row.deptName,
    onOk() {
      deleteRegionSetting({id: row.id}).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}

onMounted(() => {
  fetchDeptInfo()
})

</script>
  
  <style scoped></style>
  